// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-container[data-v-106c86ed]{height:100%;padding:15px;background-color:#f0f2f5}.dashboard-container .dashboard[data-v-106c86ed]{position:relative;margin-bottom:10px;border-radius:5px;overflow:hidden}.dashboard-container .dashboard .control[data-v-106c86ed]{position:absolute;right:15px;top:15px;z-index:1}.dashboard-container .dashboard .el-icon-more[data-v-106c86ed]{-webkit-transform:rotate(90deg);transform:rotate(90deg)}\n", ""]);
// Exports
module.exports = exports;
